<template>
  <div>
    <p class="mt-4">
      Lijst met gebeurtenissen behorende bij dit proces
    </p>
    <b-alert
      :show="true"
      variant="warning"
    >
      Dit is een vroege preview. Deze functie is nog niet gereed voor productie.
    </b-alert>

    <div>
      <div
        v-for="(eventGroupByVersion,index) in eventsByVersionByUserAndTime"
        :key="`eventVersionGroup_${index}`"
      >
        <strong>
          Locatie voorstel {{ eventGroupByVersion.version }}
        </strong>

        <div
          v-for="(eventGroup,versionIndex) in eventGroupByVersion.groupedEvents"
          :key="`eventGroup_${versionIndex}`"
        >
          {{ index }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    events() {
      try {
        return this.record.Events || []
      } catch (e) {
        return []
      }
    },

    eventsByVersionByUserAndTime() {
      let result = this.events
        .reduce((groupedEvents, event) => {
          let userAndTime = `${event.userId}-${event.ts}`
          let version = event.version || 1

          // First event with this version
          if (! groupedEvents[version]) {
            groupedEvents[version] = {
              version,
              groupedEvents: {},
            }
          }

          // First event with user + time combination
          if (! groupedEvents[version].groupedEvents[userAndTime]) {
            groupedEvents[version].groupedEvents[userAndTime] = {
              userId: event.userId,
              ts: event.ts,
              events: [],
            }
          }

          groupedEvents[version].groupedEvents[userAndTime].events.push(
            event,
          )

          return groupedEvents
        }, {})

      // console.log(result)

      return result

    },
  },
}
</script>
